export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9456.d9e57b9f.jpg";